import { Utilities } from '@shared/utilities/utilities.model';

export class PracticeModel {
	id: string;
	practice_id: string;
	practice_type: string;
	plate: string;
	created_at: string;
	status: string;
	processing_types: string[];
	

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.created_at = model.created_at;
			this.id = model.id;
			this.practice_id = model.practice_id;
			this.plate = model.plate;
			this.practice_type = model.practice_type;
			this.status = model.status;
			this.processing_types = [];
			if (model.processing_types) {
				model.processing_types.forEach(el => {
					this.processing_types.push(el);
				});
			}
		}
	}
}